export default "__VITE_ASSET__0728b866__"